<template>
    <div>
        <div class="c-form">
            <div class="c-form__fieldset" :class="{ 'c-form__group--error': $v.newGroup.$error }">
                <div class="row c-form__group">
                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-2">
                        <label class="c-form__label" for="group_name">Group name</label>
                    </div>
                    <div class="col-xs-12 col-sm-9 col-md-9 col-lg-10">
                        <input v-model.trim="newGroup" type="text" id="group_name" class="c-form__field" />
                    </div>
                    <div
                        v-if="!$v.newGroup.required"
                        class="col-xs-12 col-sm-6 offset-sm-6 col-md-6 offset-md-2 c-form__error"
                    >
                        <p class="label--error">Group name is required</p>
                    </div>
                    <div
                        v-if="!$v.newGroup.maxLength"
                        class="col-xs-12 col-sm-6 offset-sm-6 col-md-6 offset-md-2 c-form__error"
                    >
                        <p class="label--error">The Group name can not have more than 30 characters.</p>
                    </div>
                </div>
            </div>
            <div class="c-form__fieldset">
                <div class="row c-form__group">
                    <div class="col-xs-12 col-sm-6 col-md-6 offset-md-3 offset-lg-2 col-lg-5 col-xl-4">
                        <button class="c-btn c-btn--success" @click="addDomainGroup()">
                            <fa :icon="['far', 'plus-square']"></fa> Add group
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <h5>Group List</h5>
        <div v-if="groups.length" class="c-table">
            <template v-for="group of groups">
                <div :key="group.id" class="c-table__row">
                    <template v-if="editingGroupId !== group.id">
                        <div class="c-table__data name">
                            {{ group.group_name }}
                        </div>
                        <div class="c-table__data c-table__action">
                            <button class="c-btn c-btn--info" @click="startEdit(group.id, group.group_name)">
                                Edit
                            </button>
                        </div>
                        <div class="c-table__data c-table__action">
                            <button
                                class="c-btn c-btn--table c-btn--remove"
                                :title="'Delete Group ' + group.group_name"
                                @click="removeGroup(group.id, group.group_name)"
                            >
                                <span class="ccs-table__icon icon-delete-ccs icon-ccs"></span>
                            </button>
                        </div>
                    </template>

                    <template v-else>
                        <div class="c-table__data input">
                            <input type="text" class="c-form__field" v-model="editingGroupName" />
                        </div>
                        <div class="c-table__data c-table__action">
                            <button class="c-btn c-btn--success" @click="saveEdit">Save</button>
                        </div>
                        <div class="c-table__data c-table__action">
                            <button class="c-btn c-btn--table c-btn--remove" @click="cancelEdit" title="Cancel Changes">
                                <fa :icon="['fas', 'ban']"></fa>
                            </button>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { required, maxLength } from "vuelidate/lib/validators";

export default {
    title: "Manage Domain Groups",

    props: ["groups"],

    data: function() {
        return {
            newGroup: "",
            editingGroupId: 0,
            editingGroupName: ""
        };
    },

    validations: {
        newGroup: {
            required,
            maxLength: maxLength(30)
        },
        editingGroupName: {
            required,
            maxLength: maxLength(30)
        }
    },

    methods: {
        removeGroup(id, name) {
            let payload = {
                data: {
                    group_id: id
                }
            };

            let r = this.$laroute.route("domains_ajax_remove_group");

            this.$modal.show("ccs-modal-dialog", {
                type: "warning",
                title: `Are you sure?`,
                text: `This will delete group <em>${name}</em> ?`,
                buttons: [
                    {
                        title: "Yes, delete it!",
                        class: "c-btn c-btn--success c-btn--primary",
                        handler: () => {
                            this.$modal.hide("ccs-modal-dialog");
                            this.$notify({
                                type: "info",
                                title: `Deleting group...`,
                                text: `<em>${name}</em>`
                            });
                            this.$axios
                                .post(r, payload)
                                .then((response) => {
                                    if (response.data.status === "OK") {
                                        this.$notify({
                                            type: "success",
                                            title: "Domain group removed"
                                        });
                                        this.$parent.$parent.$parent.getDomainsData();
                                    } else {
                                        if (response.data.message === "DELETE_GROUP_MUST_NOT_HAVE_DOMAINS") {
                                            this.$modal.show("ccs-modal-dialog", {
                                                title: "Can not delete group",
                                                text:
                                                    "Unable to delete group as it is associated with domain(s). Assign the domain(s) to another group and try again.",
                                                buttons: [
                                                    {
                                                        title: "Close",
                                                        class: "c-btn c-btn--success c-btn--primary",
                                                        handler: () => {
                                                            this.$modal.hide("ccs-modal-dialog");
                                                        },
                                                        default: true // Will be triggered by default if 'Enter' pressed.
                                                    }
                                                ]
                                            });
                                        } else {
                                            this.$notify({
                                                type: "error",
                                                title: "Error saving group"
                                            });
                                        }
                                    }
                                })
                                .finally((_) => {
                                    this.cancelEdit();
                                });
                        }
                    },
                    {
                        title: "Close",
                        default: true // Will be triggered by default if 'Enter' pressed.
                    }
                ]
            });
        },
        saveEdit() {
            this.$v.editingGroupName.$touch();
            if (this.$v.editingGroupName.$invalid) {
                let errorMessage = [];

                if (!this.$v.editingGroupName.required) {
                    errorMessage.push("Group name is required.");
                }

                if (!this.$v.editingGroupName.maxLength) {
                    errorMessage.push("The Group name can not have more than 30 characters.");
                }

                this.$notify({
                    type: "error",
                    title: "Error saving group",
                    text: errorMessage.join("<br>")
                });

                return;
            }

            let payload = {
                data: {
                    new_group_name: this.editingGroupName,
                    group_id: this.editingGroupId
                }
            };

            let r = this.$laroute.route("domains_ajax_edit_group");
            this.$axios
                .post(r, payload)
                .then((response) => {
                    if (response.data.status === "OK") {
                        this.$notify({
                            type: "success",
                            title: "Domain group updated"
                        });
                        this.$parent.$parent.$parent.getDomainsData();
                    } else {
                        this.$notify({
                            type: "error",
                            title: "Error saving group"
                        });
                    }
                })
                .finally((_) => {
                    this.cancelEdit();
                });
        },
        startEdit(id, name) {
            this.editingGroupId = id;
            this.editingGroupName = name;
        },
        cancelEdit() {
            this.editingGroupId = 0;
            this.editingGroupName = "";
        },
        addDomainGroup() {
            this.$v.newGroup.$touch();
            if (this.$v.newGroup.$invalid) {
                return;
            }

            let payload = {
                data: {
                    group_id: this.editingGroupId,
                    group_name: this.newGroup
                }
            };

            let r = this.$laroute.route("domains_ajax_add_group");
            this.$axios.post(r, payload).then((response) => {
                if (response.data.status === "OK") {
                    this.newGroup = "";
                    this.$v.$reset();

                    this.$notify({
                        type: "success",
                        title: "Domain group added"
                    });
                    this.$parent.$parent.$parent.getDomainsData();
                } else {
                    this.$notify({
                        type: "error",
                        title: "Error saving group",
                        text: response.data.message
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.c-table__data {
    word-break: break-all;
}

.c-table__data.input {
    padding: 0;
}
</style>
